import { Grid } from 'react-styled-flexboxgrid';
import styled, { css } from 'styled-components';

import { TSpacing } from './types';
import { customMarginStyles, customPaddingStyles } from '../../../styles/Shared/SharedStyles';
import { mediaDown, mediaUp } from '../../../styles/Shared/MediaQueries';
import Theme from '../../../styles/Theme/Theme';
import { CSSProperties } from 'react';

type TSCustomProps = {
    bg?: keyof typeof Theme.color;
};

export const Container = styled(Grid) <TSpacing & TSCustomProps & CSSProperties>`
    background-color: ${({ bg, theme }) => (bg ? theme.color[bg] : null)};

    ${customMarginStyles}

    ${customPaddingStyles}

    // small
    ${mediaDown.small} {
        width: calc(100% - 40px);
    }

    ${mediaUp.small} {
        width: calc(100% - 40px);
    }

    // medium
    ${mediaUp.medium} {
        width: calc(100% - 40px);
    }

    // large
    ${mediaUp.large} {
        width: calc(100% - 64px);
    }

    // xlarge
    ${mediaUp.xlarge} {
        width: calc(100% - 128px);
    }

    // Fluid container
    ${({ fluid }) =>
        fluid
            ? css`
                  width: auto !important;
              `
            : null}
`;
